module.exports = __webpack_public_path__ + "static/img/app_menu_arc@2x.8e7be3cf.png";